import {slideToggle, slideUp, index} from '../utility/utils';
import { smoother } from '../utility/gsap';

function toggleAccordion(e){
  e.preventDefault();

  if(e.type === 'click' || e.key === 'Enter' ){

    const el = e.target;
    const accordionList = el.closest('.accordion__list');
    const accordion_items = !!el.closest('.accordion__item') ? [el.closest('.accordion__item')] : [];
    const openAllTogether = accordionList && accordionList.classList.contains('toggle_all');

    if(!el.nextElementSibling && !openAllTogether){
      return;
    }

    let topOffset = 0;

    if(accordionList){
      // If toggling all together, add items to the accordion_items array
      if(openAllTogether){
        const allItems = accordionList.querySelectorAll('.accordion__item');
        allItems.forEach(item => {
          if(accordion_items.length < 1 || item !== accordion_items[0]){
            accordion_items.push(item);
          }
        });
      }
      // Close any open items within accordion list that isn't this element
      else{
        if(!el.nextElementSibling){
          return;
        }
        const activeListItem = accordionList.querySelector('.accordion__item.active');
        if(activeListItem && activeListItem !== accordion_items[0]){
          const activeTrigger = activeListItem.querySelector('.accordion__trigger');
          const activeContent = activeListItem.querySelector('.accordion__content');
  
          activeListItem.classList.remove('active');
          activeTrigger.classList.remove('active');
          activeContent.classList.remove('active');
  
          // If the previously active item is above the new accordion item, alter the topOffset variable
          const activeIndex   = index(activeListItem);
          const clickedIndex  = index(accordion_items[0]);
          if(activeIndex < clickedIndex){
            topOffset = activeContent.offsetHeight;
          }
  
          activeContent.setAttribute('aria-hidden', 'true');
          slideUp(activeContent);
        }
      }
    }

    // Toggle active class
    accordion_items.forEach(item => {
      // Accordion item
      item.classList.toggle('active');
      
      // Trigger Button
      const button = item.querySelector('.accordion__trigger');
      button.classList.toggle('active');
      
      // Target Content
      const target = button.nextElementSibling;
      target.classList.toggle('active');
      
      // Toggle Aria-Hidden attribute
      const aria_hidden = target.classList.contains('active') ? 'false' : 'true';
      target.setAttribute('aria-hidden', aria_hidden);

      // Toggle Content Height
      slideToggle(target);

      // If the accordion list includes a .accordion__trigger_all element, toggle the text
      if(openAllTogether && accordionList.querySelector('.accordion__trigger_all')){
        const allTrigger = accordionList.querySelector('.accordion__trigger_all .btn__text');
        if(allTrigger){
          const closeText = allTrigger.closest('.accordion__trigger_all').getAttribute('data-closed-text');
          const openText = allTrigger.closest('.accordion__trigger_all').getAttribute('data-open-text');
          allTrigger.innerHTML = item.classList.contains('active') ? openText : closeText;
          allTrigger.closest('.accordion__trigger_all').classList.toggle('active');
          console.log('test');
        }
      }
    });

    // Slide window to active item position if it has gone outside of the screen
    if(!openAllTogether){
      const scrollPos = window.pageYOffset | document.body.scrollTop;
      let elTopPos = accordion_items[0].getBoundingClientRect().top + scrollPos;
      const adminBarEl = document.getElementById("wpadminbar");
      const adminBarHeight = adminBarEl ? adminBarEl.offsetHeight : 0;
      if(topOffset !== 0 && (elTopPos - topOffset) < (scrollPos + adminBarHeight)){
        document
        elTopPos = elTopPos - adminBarHeight - 20 - topOffset;
        document.body.classList.add('preventHeaderReveal');
        
        if(smoother){
          document.body.classList.add('prevent-smoother-update');
  
          smoother.scrollTo(elTopPos, true, "top");
          
          setTimeout(() => {
            document.body.classList.remove('prevent-smoother-update');
          }, 300);
        }
        else {
          scroll({
            top: elTopPos,
            behavior: "smooth",
          });
        }
          
        setTimeout(() => {
          document.body.classList.remove('preventHeaderReveal');
        }, 600);
      }
    }
  }
}


export const initializeAccordions = (event) => {
  // Accordion Toggle
  const accordions = document.querySelectorAll('.accordion__trigger, .accordion__trigger_all');
  accordions.forEach(item => {
    item.addEventListener('click', toggleAccordion);
    item.addEventListener('keypress', toggleAccordion);
  });
};


